import { ColumnsType } from 'antd/lib/table'
import { BpTable } from '../../../../shared/components/cards/table/BpTable'
import { useTranslation } from 'react-i18next'
import { StatusCell } from '../../ui/cells/StatusCell'
import { useGetReferralPayoutsListQuery } from '../../../../app/api'

export const PayoutsList = () => {
  const { t } = useTranslation()

  const { data, isLoading, isFetching } = useGetReferralPayoutsListQuery()

  const columns: ColumnsType<any> = [
    {
      title: t('table.columns.amount'),
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: t('table.columns.status'),
      dataIndex: 'status',
      key: 'status',
      render: (_: string, record) => <StatusCell {...record} />,
    },
    {
      title: t('table.columns.requestedAt'),
      dataIndex: 'requested_at',
      key: 'requested_at',
    },
    {
      title: t('table.columns.processedAt'),
      dataIndex: 'processed_at',
      key: 'processed_at',
    },
  ]

  return (
    <div>
      <BpTable
        columns={columns}
        dataSource={data?.data?.items}
        hidePagination={true}
        loading={isLoading || isFetching}
        scroll={{ x: 420 }}
      />
    </div>
  )
}
